import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect } from "react";
import { api__createPaymentSession, OrderPaidError, PostReservedError } from "@/apis/checkout/createSession";
import Checkout from "@/pages/checkout/CheckoutV2/Checkout";
import useApi from "@hooks/useApi";
import TechnicalError from "@/pages/schedule/components/TechnicalError";
import { useTranslation } from "@i18n";
import Layout from "@/_LayoutsRelated/layout/Layout";
import "@/pages/checkout/moyasar/styles.css";
import ReservedMessage from "@/pages/checkout/CheckoutV2/components/ReservedMessage/ReservedMessage";
import OrderPaidMessage from "@/pages/checkout/CheckoutV2/components/OrderPaidMessage/OrderPaidMessage";
import useHelpers from "@hooks/useHelpers";
import { useCheckoutOrder } from "@/common/Contexts/CheckoutOrderContext";
import { toast } from "sonner";
import MobileHeaderwithCancleFunction from "@/_LayoutsRelated/mobileHeaders/mobileHeaderwithCancleFunction/MobileHeaderwithCancleFunction";
import useIsWebView from "@hooks/useIsWebview";
import { FullPaymentFormShimmer, CompactPaymentFormShimmer } from "@/pages/checkout/CheckoutV2/components/PaymentCreditCardShimmer";
import useIsMobile from "@hooks/useIsMobile";
import Loader from "@componentsShared/Loader/Loader";
import useBFCacheBuster from "@hooks/useBFCacheBuster";
import useCheckABFlag from "@hooks/useCheckABFlag";
import { useAbandonmentTracking } from "@/common/Contexts/AbandonmentTrackingContext";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import useCookieClient from "@hooks/useCookieClient";
var showErrorToast = function showErrorToast(msg) {
  toast.error(msg, {
    position: "bottom-center",
    duration: 5000,
    style: {
      zIndex: 9999999
    }
  });
};
var LayoutCheckout = function LayoutCheckout(_ref) {
  var checkoutOrder = _ref.checkoutOrder,
    children = _ref.children;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var isWebview = useIsWebView();
  return /*#__PURE__*/React.createElement(Layout, {
    hideOrangeHeadBtn: true,
    disableLoader: true,
    authenticationMsg: true,
    mainClass: "CheckOut",
    logoNotClickable: true,
    headHideLinks: true,
    hideMenu: true,
    hideAppBanner: true,
    hideHeaderOnmobile: true,
    custommobileHeader: !isWebview && /*#__PURE__*/React.createElement(MobileHeaderwithCancleFunction, {
      title: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.post_title,
      buttonFunction: function buttonFunction() {
        return navigateTo("/checkout/shop-apply?post_id=".concat(checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.post_id));
      }
    })
  }, children);
};
var CheckoutRender = function CheckoutRender() {
  // This is to buster the BFCache in case of navigating back to this page
  useBFCacheBuster();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useSession = useSession(),
    user = _useSession.user;
  var _useCookieClient = useCookieClient(),
    getCookieClient = _useCookieClient.getCookieClient;
  var isMobile = useIsMobile();
  var isWebview = useIsWebView();
  var _useCheckoutOrder$que = useCheckoutOrder().queryParams,
    post_id = _useCheckoutOrder$que.post_id,
    order_id = _useCheckoutOrder$que.order_id;
  var action__initFormData = useCheckoutOrder().actions.action__initFormData;
  var referralData = useCheckoutOrder().state.referralData;
  var _useHelpers2 = useHelpers(),
    createUrlAbsolute = _useHelpers2.createUrlAbsolute;
  var _useAbandonmentTracki = useAbandonmentTracking(),
    startAbandonmentTracking = _useAbandonmentTracki.startAbandonmentTracking,
    completeAbandonmentTracking = _useAbandonmentTracki.completeAbandonmentTracking;
  var paymentProcessingUrl = createUrlAbsolute("/process-payment-moyasar-callback", {
    order_id: order_id,
    post_id: post_id
  }).replace('localhost:3000', 'https://local.syarah.com');
  useEffect(function () {
    console.log('[TEST] BFCache');
    action__initFormData();
  }, []);
  var AB_PAYMENT_CHECKOUT = useCheckABFlag("AB_PAYMENT_CHECKOUT.COM");
  var AB_PAYMENT_MOYASAR = useCheckABFlag("AB_PAYMENT_MOYASAR");
  var AB__gateway_type = AB_PAYMENT_CHECKOUT === true ? "checkout.com" : AB_PAYMENT_MOYASAR === true ? "moyasar" : null;
  var gatewayType = AB__gateway_type || null;
  var _useApi = useApi([order_id], function () {
      return api__createPaymentSession(_objectSpread({
        order_id: order_id,
        paymentProcessingUrl: paymentProcessingUrl
      }, gatewayType ? {
        gateway_type: gatewayType
      } : {}));
    }),
    _useApi2 = _slicedToArray(_useApi, 3),
    loading = _useApi2[0],
    error = _useApi2[1],
    apiData = _useApi2[2];
  var _ref2 = apiData || {},
    session = _ref2.session,
    checkoutOrder = _ref2.order_details;
  var showLoading = loading || !checkoutOrder && !error;
  useEffect(function () {
    if (!order_id || !(checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.g4_data_layer)) return;
    var g4Data = (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.g4_data_layer) || {};
    startAbandonmentTracking({
      key: "add_payment_info_abandoned_".concat(order_id),
      event: "add_payment_info_abandoned",
      shouldTrack: true,
      payload: _objectSpread(_objectSpread({
        order_id: (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.id) || order_id
      }, g4Data), {}, {
        inventory_type: g4Data === null || g4Data === void 0 ? void 0 : g4Data.inventory_type_string,
        post_trim: g4Data === null || g4Data === void 0 ? void 0 : g4Data.post_ext,
        total_amount: checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.total_price ? parseFloat(String(checkoutOrder.total_price).replace(/,/g, "")) : undefined,
        discount_code: (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.referral_code) || "",
        payment_option: (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.payment_type) || ""
      })
    });
  }, [checkoutOrder, order_id, startAbandonmentTracking]);
  useEffect(function () {
    if (error) {
      console.error({
        error: error
      });
      if (error instanceof OrderPaidError) {
        showErrorToast(t('order_already_paid', {
          ns: 'web_common'
        }));
        return;
      }
      if (error instanceof PostReservedError) {
        showErrorToast(t('post_already_reserved', {
          ns: 'web_common'
        }));
        return;
      }
      if (error.trace) {
        showErrorToast(error.trace);
      } else {
        showErrorToast(error.message);
      }
    }
  }, [error]);
  useEffect(function () {
    if (!error || !order_id) return;
    if (error instanceof OrderPaidError || error instanceof PostReservedError) {
      completeAbandonmentTracking("add_payment_info_abandoned_".concat(order_id));
    }
  }, [completeAbandonmentTracking, error, order_id]);
  if (showLoading) {
    if (isMobile) {
      return /*#__PURE__*/React.createElement(LayoutCheckout, {
        checkoutOrder: checkoutOrder
      }, isWebview && /*#__PURE__*/React.createElement(CompactPaymentFormShimmer, null), !isWebview && /*#__PURE__*/React.createElement(FullPaymentFormShimmer, null));
    } else {
      return /*#__PURE__*/React.createElement(LayoutCheckout, {
        checkoutOrder: checkoutOrder
      }, /*#__PURE__*/React.createElement(Loader, null));
    }
  }
  if (error) {
    if (error instanceof OrderPaidError) {
      return /*#__PURE__*/React.createElement(LayoutCheckout, {
        checkoutOrder: checkoutOrder
      }, /*#__PURE__*/React.createElement(OrderPaidMessage, {
        order_id: order_id
      }));
    } else if (error instanceof PostReservedError) {
      return /*#__PURE__*/React.createElement(LayoutCheckout, {
        checkoutOrder: checkoutOrder
      }, /*#__PURE__*/React.createElement(ReservedMessage, null));
    } else {
      return /*#__PURE__*/React.createElement(LayoutCheckout, {
        checkoutOrder: checkoutOrder
      }, /*#__PURE__*/React.createElement(TechnicalError, {
        text: t("error_technical_error_occurred", {
          ns: "web_tracking"
        })
      }));
    }
  }
  return /*#__PURE__*/React.createElement(LayoutCheckout, {
    checkoutOrder: checkoutOrder
  }, /*#__PURE__*/React.createElement(Checkout, {
    referralData: referralData,
    checkoutOrder: checkoutOrder,
    paymentSession: session,
    paymentProcessingUrl: paymentProcessingUrl
  }));
};
export default CheckoutRender;